module.exports = __webpack_public_path__ + "static/media/stocks.676b53cb.svg";